module.exports = __webpack_public_path__ + "static/4-7042e55f9153d819ea489321d5489421.jpg";